import React from "react";
import { SHr, SIcon, SImage, SNavigation, SPage, SText, STheme, SView } from "servisofts-component";
import Model from "../Model";

export default class index extends React.Component {
  componentDidMount() {
    if (!Model.usuario.Action.getUsuarioLog()) {
      //SNavigation.replace("client");
      SNavigation.replace("login");
      return null;
    }
  }
  render() {
    return <SPage title={"Home"} preventBack center disableScroll >
      <SImage src={require("../Assets/img/banner.jpg")} style={{ resizeMode: "cover", position: "absolute", opacity: "40%" }} />
      <SView col={"xs-10"} center>
        <SIcon name="logoWhite" width={250} height={150} fill={STheme.color.text} />
        <SView col={"xs-11 sm-7"} style={{ backgroundColor: "#E3061350", borderRadius: 30 }} padding={20} center>
          <SHr height={10} />
          <SText fontSize={22} bold center>¡Hemos mejorado tu experiencia!</SText>
          <SHr height={15} />
          <SText center fontSize={18}>Ahora encontrarás un menú lateral izquierdo más organizado y fácil de navegar.</SText>
          <SHr />
          <SText center fontSize={18}> Explora los módulos desde un acceso más rápido y ordenado.</SText>
          <SHr height={10} />
        </SView>
      </SView>

    </SPage>
  }
}